import {
  ecwGettingPaymentDataFromVertical as ecwGettingPaymentDataFromVerticalOriginal,
  ecwPsd2OvercaptureFlow as ecwPsd2OvercaptureFlowOriginal,
  fastCheckoutButtonClicked as fastCheckoutButtonClickedOriginal,
  paymentModalClosed as paymentModalClosedOriginal,
  spbButtonRendered as spbButtonRenderedOriginal,
  spbButtonStartInitializationCheckout as spbButtonStartInitializationCheckoutOriginal,
  spbButtonSuccessInitializationCheckout as spbButtonSuccessInitializationCheckoutOriginal,
  spbButtonTrxAuthorized as spbButtonTrxAuthorizedOriginal,
  spbCountryMissed as spbCountryMissedOriginal,
  spbErrorDuringStartInitializationCheckout as spbErrorDuringStartInitializationCheckoutOriginal,
  spbErrorDuringValidationFromVertical as spbErrorDuringValidationFromVerticalOriginal,
  spbShippingMethodChanged as spbShippingMethodChangedOriginal,
  spbShippingMethodNotAccepted as spbShippingMethodNotAcceptedOriginal,
  transaction3DsForm as transaction3DsFormOriginal,
} from '@wix/bi-logger-cashier-ugc/v2';
import {
  ecwGettingPaymentDataFromVerticalParams as ecwGettingPaymentDataFromVerticalParamsOriginal,
  ecwPsd2OvercaptureFlowParams as ecwPsd2OvercaptureFlowParamsOriginal,
  fastCheckoutButtonClickedParams as fastCheckoutButtonClickedParamsOriginal,
  paymentModalClosedParams as paymentModalClosedParamsOriginal,
  spbButtonRenderedParams as spbButtonRenderedParamsOriginal,
  spbButtonStartInitializationCheckoutParams as spbButtonStartInitializationCheckoutParamsOriginal,
  spbButtonSuccessInitializationCheckoutParams as spbButtonSuccessInitializationCheckoutParamsOriginal,
  spbButtonTrxAuthorizedParams as spbButtonTrxAuthorizedParamsOriginal,
  spbCountryMissedParams as spbCountryMissedParamsOriginal,
  spbErrorDuringStartInitializationCheckoutParams as spbErrorDuringStartInitializationCheckoutParamsOriginal,
  spbErrorDuringValidationFromVerticalParams as spbErrorDuringValidationFromVerticalParamsOriginal,
  spbShippingMethodChangedParams as spbShippingMethodChangedParamsOriginal,
  spbShippingMethodNotAcceptedParams as spbShippingMethodNotAcceptedParamsOriginal,
  transaction3DsFormParams as transaction3DsFormParamsOriginal,
} from '@wix/bi-logger-cashier-ugc/v2/types';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentMethodFundingSource, PaymentsButtonPlace } from '../../../types/PaymentsButtonViewConfig';

export type paymentModalClosedParams = paymentModalClosedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const paymentModalClosed: (p: paymentModalClosedParams) => ReturnType<typeof paymentModalClosedOriginal> =
  paymentModalClosedOriginal;
export type fastCheckoutButtonClickedParams = fastCheckoutButtonClickedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const fastCheckoutButtonClicked: (
  p: fastCheckoutButtonClickedParams,
) => ReturnType<typeof fastCheckoutButtonClickedOriginal> = fastCheckoutButtonClickedOriginal;

export type ecwGettingPaymentDataFromVerticalParams = ecwGettingPaymentDataFromVerticalParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
  stepName: 'initialization' | 'result';
  result?: 'success' | 'failure';
};

export const ecwGettingPaymentDataFromVertical: (
  p: ecwGettingPaymentDataFromVerticalParams,
) => ReturnType<typeof ecwGettingPaymentDataFromVerticalOriginal> = ecwGettingPaymentDataFromVerticalOriginal;

export type spbButtonRenderedParams = spbButtonRenderedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
  renderPlace: PaymentsButtonPlace;
};

export const spbButtonRendered: (p: spbButtonRenderedParams) => ReturnType<typeof spbButtonRenderedOriginal> =
  spbButtonRenderedOriginal;

export type spbButtonStartInitializationCheckoutParams = spbButtonStartInitializationCheckoutParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const spbButtonStartInitializationCheckout: (
  p: spbButtonStartInitializationCheckoutParams,
) => ReturnType<typeof spbButtonStartInitializationCheckoutOriginal> = spbButtonStartInitializationCheckoutOriginal;

export type spbButtonSuccessInitializationCheckoutParams = spbButtonSuccessInitializationCheckoutParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const spbButtonSuccessInitializationCheckout: (
  p: spbButtonSuccessInitializationCheckoutParams,
) => ReturnType<typeof spbButtonSuccessInitializationCheckoutOriginal> = spbButtonSuccessInitializationCheckoutOriginal;

export type spbButtonTrxAuthorizedParams = spbButtonTrxAuthorizedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const spbButtonTrxAuthorized: (
  p: spbButtonTrxAuthorizedParams,
) => ReturnType<typeof spbButtonTrxAuthorizedOriginal> = spbButtonTrxAuthorizedOriginal;

export type spbCountryMissedParams = spbCountryMissedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod;
};

export const spbCountryMissed: (p: spbCountryMissedParams) => ReturnType<typeof spbCountryMissedOriginal> =
  spbCountryMissedOriginal;

export type spbErrorDuringStartInitializationCheckoutParams =
  spbErrorDuringStartInitializationCheckoutParamsOriginal & {
    paymentProvider: PaymentProvider;
    paymentmethod: PaymentMethodFundingSource;
  };

export const spbErrorDuringStartInitializationCheckout: (
  p: spbErrorDuringStartInitializationCheckoutParams,
) => ReturnType<typeof spbErrorDuringStartInitializationCheckoutOriginal> =
  spbErrorDuringStartInitializationCheckoutOriginal;

export type spbErrorDuringValidationFromVerticalParams = spbErrorDuringValidationFromVerticalParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const spbErrorDuringValidationFromVertical: (
  p: spbErrorDuringValidationFromVerticalParams,
) => ReturnType<typeof spbErrorDuringValidationFromVerticalOriginal> = spbErrorDuringValidationFromVerticalOriginal;

export type spbShippingMethodChangedParams = spbShippingMethodChangedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod;
};

export const spbShippingMethodChanged: (
  p: spbShippingMethodChangedParams,
) => ReturnType<typeof spbShippingMethodChangedOriginal> = spbShippingMethodChangedOriginal;

export type spbShippingMethodNotAcceptedParams = spbShippingMethodNotAcceptedParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod;
};

export const spbShippingMethodNotAccepted: (
  p: spbShippingMethodNotAcceptedParams,
) => ReturnType<typeof spbShippingMethodNotAcceptedOriginal> = spbShippingMethodNotAcceptedOriginal;

export type ecwPsd2OvercaptureFlowParams = ecwPsd2OvercaptureFlowParamsOriginal & {
  paymentProvider?: PaymentProvider;
  paymentmethod: PaymentMethodFundingSource;
};

export const ecwPsd2OvercaptureFlow: (
  p: ecwPsd2OvercaptureFlowParams,
) => ReturnType<typeof ecwPsd2OvercaptureFlowOriginal> = ecwPsd2OvercaptureFlowOriginal;

export type transaction3DsFormParams = transaction3DsFormParamsOriginal & {
  paymentProvider: PaymentProvider;
  paymentMethod: PaymentMethod;
};

export const transaction3DsForm: (p: transaction3DsFormParams) => ReturnType<typeof transaction3DsFormOriginal> =
  transaction3DsFormOriginal;
